
    // src/pages/Singing.jsx

    import { Fragment, useEffect, useState } from "react";

    import { Link, useParams, useLocation } from "react-router-dom";

    import Footer from "../component/layout/footer";

    import Header from "../component/layout/header";

    import Rating from "../component/sidebar/rating";
    import { useMemo,useRef } from "react";

    import "./singing.css";
    import { createPortal } from "react-dom";

    import profile_image from "../assets/images/art/profile_image.jpg";

    import { jwtDecode } from "jwt-decode";

    import { useNavigate } from "react-router-dom";

    const Singing = () => {
      // const { category } = useParams();

      const location = useLocation();
      const [showImagePreview, setShowImagePreview] = useState(false);
      const [previewImage, setPreviewImage] = useState("");

      const [allSkills, setAllSkills] = useState([]);

      const [tutorList, setTutorList] = useState([]);

      const [allTutors, setAllTutors] = useState([]);

      const [loading, setLoading] = useState(true);

      const [error, setError] = useState("");

      const [pageSkills, setPageSkills] = useState([]);

      const [currentPage, setCurrentPage] = useState(1);
      const [isExpanded, setIsExpanded] = useState(false);
      
      const itemsPerPage = 6;

      const [likedTutors, setLikedTutors] = useState({});
      const [dbGenders, setDbGenders] = useState([]);
    const [dbModes, setDbModes] = useState([]);
    const [dbLanguages, setDbLanguages] = useState([]);
    const [dbStates, setDbStates] = useState([]);
    const [dbCountries,setDbCountries] =useState([]);


    // EXPERIENCE
  const [tempExperience, setTempExperience] = useState({ min: "", max: "" });
  const [activeExperience, setActiveExperience] = useState(null);
  const navigate = useNavigate();

  // STATE
  const [tempStates, setTempStates] = useState([]);
  const [tempCountries,setTempCountries] =useState([]);
  const [activeCountries, setActiveCountries] = useState([]);
  const [activeStates, setActiveStates] = useState([]);

  // MORE CATEGORY (for SEARCH ALL)
  const [tempCategories, setTempCategories] = useState([]);
  const [activeCategories, setActiveCategories] = useState([]);
const [expanded, setExpanded] = useState(false);


  const [refreshTutorsKey, setRefreshTutorsKey] = useState(0);

          const MODE_MAP = [
    { label: "Online", value: "Online" },
    { label: "Offline", value: "Offline" },
    { label: "Home Visit", value: "Home Visit" }
  ];

const [dbAreas, setDbAreas] = useState([]);

const [tempAreas, setTempAreas] = useState([]);
const [activeAreas, setActiveAreas] = useState([]);

const [areaSearch, setAreaSearch] = useState("");



      // FALLBACK ADS
      const fallbackAds = [
        { imgUrl: "/assets/images/art/Sing1.png" },

        { imgUrl: "/assets/images/art/Sing2.png" },

        { imgUrl: "/assets/images/art/Sing3.png" },
      ];

      const [adsList, setAdsList] = useState(fallbackAds);

      // Query params for name / city / pincode search

      const queryParams = new URLSearchParams(location.search);

      const searchName = queryParams.get("name")?.toLowerCase() || "";

      const searchCity = queryParams.get("city") || "";

      const searchPincode = queryParams.get("pincode")?.toString().trim() || "";

      const searchQuery = queryParams.get("q")?.toLowerCase().trim() || "";
     const [activeCities, setActiveCities] = useState([]);
      const [tempCities, setTempCities] = useState([]);
      const [tempSkills, setTempSkills] = useState([]); // ✅ ADD THIS
      const [comments, setComments] = useState([]);

      const [newComment, setNewComment] = useState("");

      const [editingComment, setEditingComment] = useState(null);

      const [apiCities, setApiCities] = useState([]);

      const [tempGenders, setTempGenders] = useState([]);
    const [tempModes, setTempModes] = useState([]);
    const [tempDemo, setTempDemo] = useState(null);

    const [activeGenders, setActiveGenders] = useState([]);
    const [activeModes, setActiveModes] = useState([]);
    const [activeDemo, setActiveDemo] = useState(null);
    const [tempLanguages, setTempLanguages] = useState([]);
    const [activeLanguages, setActiveLanguages] = useState([]);
    const [applyTick, setApplyTick] = useState(0);

    const normalizeValue = (v) => v?.toString().toLowerCase().trim();





      //selected tag color change

      const [selectedTags, setSelectedTags] = useState([]);

      const [allCities, setAllCities] = useState([]);
    const toggleTag = (tag) => {
      setIsFiltering(true);

      // 🔍 SEARCH ALL PAGE
      if (isSearchAll) {
        setSelectedTags((prev) => {
          const isAlreadySelected = prev.includes(tag);

          // 🔁 CLICK AGAIN → RESET TO SEARCH RESULTS
          if (isAlreadySelected) {
            setTutorList(allTutors); // 👈 restore original data
            setCurrentPage(1);
            return [];
          }

          // ✅ FIRST CLICK → FILTER BY CATEGORY
          const filtered = allTutors.filter(
            (t) =>
              t.category_name?.toLowerCase() === tag.toLowerCase()
          );

          setTutorList(filtered);
          setCurrentPage(1);

          return [tag];
        });

        setTimeout(() => setIsFiltering(false), 300);
        return;
      }

      
      // 📂 NORMAL CATEGORY PAGE (unchanged)
      setSelectedTags((prev) =>
        prev.includes(tag) ? prev.filter((t) => t !== tag) : [...prev, tag]
      );

      setTimeout(() => setIsFiltering(false), 300);
    };


      const { categoryName } = useParams();

      const decodedCategoryName = decodeURIComponent(categoryName || "");

      const decodedCategory = categoryName
        ? decodeURIComponent(categoryName)
        : "All";

      //category

      const [allcategories, setCategories] = useState([]);

      const [isFiltering, setIsFiltering] = useState(false);

      const [activeSkillCity, setActiveSkillCity] = useState(null);


const countryFilteredStates =
  tempCountries.length === 0
    ? dbStates
    : dbStates.filter(s => tempCountries.includes(Number(s.country_id)));
const stateFilteredCities = (() => {
  let base = allCities.filter(city =>
    apiCities.some(a => Number(a.id) === Number(city.id))
  );
  if (tempCountries.length > 0) {
    const validStateIds = dbStates
      .filter(s => tempCountries.includes(Number(s.country_id)))
      .map(s => s.id);
    base = base.filter(city => validStateIds.includes(city.state_id));
  }
  if (tempStates.length > 0) {  
    base = base.filter(city => tempStates.includes(city.state_id));
  }
  return base;
})();





    useEffect(() => {
  setTempStates([]);
  setActiveStates([]);
}, [tempCountries]);

      useEffect(() => {
        fetch("https://kalakakshaaha.com/kks/api/v1/arts-categories")
          .then((res) => res.json())

          .then((data) => {
            if (data.success) setCategories(data.categories); // [{id:1, skill_title:"Guitar"}]
          })

          .catch((err) => ("Skills fetch error:", err));
      }, []);


      useEffect(() => {
      fetch("https://kalakakshaaha.com/kks/api/v1/tutor-filters")
        .then(res => res.json())
        .then(data => {
          if (data.success) {
            setDbGenders(data.genders || []);
            setDbModes(data.modes || []);
            setDbLanguages(data.languages || []);
          }
        })
        .catch(err => console.error("Filter fetch error:", err));
    }, []);

useEffect(() => {
  fetch("https://kalakakshaaha.com/kks/api/v1/areas-with-tutors")
    .then(res => res.json())
    .then(data => {
      if (data.success) {
        setDbAreas(data.areas || []);
      }
    });
}, []);

    useEffect(() => {
  fetch("https://kalakakshaaha.com/kks/api/v1/countries")
    .then(res => res.json())
    .then(data => {
      if (data.success && data.countries) {
        setDbCountries(data.countries);
      }
    })
    .catch(err => console.error("Country fetch error:", err));
}, []);

const prevCitiesRef = useRef([]);

useEffect(() => {
  if (
    JSON.stringify(prevCitiesRef.current) !==
    JSON.stringify(tempCities)
  ) {
    prevCitiesRef.current = tempCities;

    setTempAreas([]);
    setActiveAreas([]);
  }
}, [tempCities]);



      useEffect(() => {
    fetch("https://kalakakshaaha.com/kks/api/v1/states")
      .then(res => res.json())
      .then(data => {
        if (data.success && data.states) {
          setDbStates(data.states);
        }
      })
      .catch(err => console.error("State fetch error:", err));
  }, []);


      useEffect(() => {
        fetch("https://kalakakshaaha.com/kks/api/v1/cities") // your endpoint
          .then((res) => res.json())

          .then((data) => {
            if (data.success && data.cities) {
              setAllCities(data.cities);
            }
          })

          .catch((err) => ("City fetch error:", err));
      }, []);
      
      useEffect(() => {
    setTempCities([]);
    setActiveCities([]);
  }, [tempStates]);

  useEffect(() => {
    fetch("https://kalakakshaaha.com/kks/api/v1/cities-with-tutors")
      .then(res => res.json())
      .then(data => {
        if (data.success && data.cities) {
          // 🔥 normalize shape
          const normalized = data.cities.map(c => ({
            id: Number(c.city_id),
            city_name: c.city_name,
            total_tutors: c.total_tutors
          }));
          setApiCities(normalized);
        }
      });
  }, []);


  useEffect(() => {
    const checkProfileUpdate = () => {
      const ts = localStorage.getItem("tutor_profile_updated");
if (ts) {
  localStorage.removeItem("tutor_profile_updated");  // 🔥 CRITICAL
  setRefreshTutorsKey(k => k + 1);
}


    };

    // ✅ Runs when user comes back to this tab
    window.addEventListener("focus", checkProfileUpdate);

    // ✅ Runs once on page load
    checkProfileUpdate();

    return () => {
      window.removeEventListener("focus", checkProfileUpdate);
    };
  }, []);



  useEffect(() => {
    const saved = localStorage.getItem("tutorFilters");
    if (!saved) return;

    const f = JSON.parse(saved);

    setTempStates(f.states || []);
    setTempCities(f.cities || []);
    setTempCategories(f.categories || []);
    setTempSkills(f.skills || []);
    setTempGenders(f.genders || []);
    setTempModes(f.modes || []);
    setTempLanguages(f.languages || []);
    setTempExperience(f.experience || {});
    setTempDemo(f.demo ?? null);
    setTempAreas(f.areas || []);
setActiveAreas(f.areas || []);

    setTempCountries(f.countries || []);
setActiveCountries(f.countries || []);


    // also sync active
    setActiveStates(f.states || []);
    setActiveCities(f.cities || []);
    setActiveCategories(f.categories || []);
    setSelectedTags(f.skills || []);
    setActiveGenders(f.genders || []);
    setActiveModes(f.modes || []);
    setActiveLanguages(f.languages || []);
    setActiveExperience(f.experience || {});
    setActiveDemo(f.demo ?? null);
  }, []);
  const filterRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (filterRef.current && !filterRef.current.contains(e.target)) {
        setOpenDropdown(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);





      const getCategoryId = (name) => {
        const s = allcategories.find(
          (sk) =>
            sk.category_name.toLowerCase().trim() === name.toLowerCase().trim()
        );

        return s ? s.id : null;
      };

      const categoryId = getCategoryId(decodedCategoryName);
            



      useEffect(() => {
        setSelectedTags([]);

        setIsFiltering(false);
      }, [categoryId]);

      //get city id by name

      const getCityIdByName = (cityName) => {
        if (!cityName) return null;

        const match = apiCities.find(
          (c) => c.city_name.toLowerCase() === cityName.toLowerCase()
        );

        return match ? match.id : null;
      };

      //get city name

      const getCityName = (cityId) => {
        const city = allCities.find((c) => Number(c.id) === Number(cityId));

        return city ? city.city_name : "";
      };

      /* ---------------------- FETCH TUTORS ---------------------- */

    /* ---------------------- FETCH TUTORS ---------------------- */
  useEffect(() => {
  

   const handler = (e) => {
  if (e.key === "tutor_profile_updated") {
    setRefreshTutorsKey(k => k + 1);
  }
};
window.addEventListener("storage", handler);


    return () => window.removeEventListener("storage", handler);
  }, []);


  useEffect(() => {
    const fetchTutors = async () => {
      setLoading(true);
      setError("");

      try {
        let url = "";
        const hasSearchParams = searchQuery || searchCity || searchName || searchPincode;

if (hasSearchParams) {
  const searchTerms = [searchQuery, searchCity, searchName, searchPincode]
    .filter(Boolean)
    .join(" ");

  const params = new URLSearchParams();
  params.append("q", searchTerms);

        url = `https://kalakakshaaha.com/kks/api/tutors-search?${params.toString()}`;
      } else {
        // 🔥 This is what was missing
        url = `https://kalakakshaaha.com/kks/api/tutors-search`;
      }



        const res = await fetch(url);
        const data = await res.json();

        if (!data.success || !data.tutors) {
          setTutorList([]);
          setAllTutors([]);
          setError("No matching tutor found.");
          setLoading(false);
          return;
        }

        let list = data.tutors;

        // ✅ NEW: Fetch full details for each tutor to get correct skills
        //console.log("🔄 Fetching full details for", list.length, "tutors...");

        
        
list = await Promise.all(
  list.map(async (tutor) => {
    try {
      const detailRes = await fetch(
        `https://kalakakshaaha.com/kks/api/v1/tutor/${tutor.user_id}`
      );
      
      if (!detailRes.ok) throw new Error("Detail fetch failed");
      
      const detailData = await detailRes.json();
      
      let detailTutor = null;
      if (detailData.success && detailData.data) {
        detailTutor = detailData.data;
      } else if (detailData.success && detailData.tutor) {
        detailTutor = detailData.tutor;
      } else if (detailData.full_name) {
        detailTutor = detailData;
      }
      
      if (detailTutor) {
        return {
          ...tutor,
          // 🔥 ADD THIS LINE - Include main area
          area: detailTutor.area ?? tutor.area,
          
          // Keep branch areas
          branch_areas: detailTutor.branch_areas ?? tutor.branch_areas,
          
          // ... rest of fields
          skills: detailTutor.skills,
          skill_names: detailTutor.skill_names,
          category_name: detailTutor.category_name || detailTutor.categories || tutor.category_name,
          display_name:
            detailTutor.tutor_type === "individual"
              ? detailTutor.full_name
              : detailTutor.contact_person || detailTutor.full_name,
          bio: detailTutor.bio,
          experience: detailTutor.experience,
          hourly_fee: detailTutor.hourly_fee,
          gender: detailTutor.gender,
          city: detailTutor.city,
          state: detailTutor.state,
          total_views: detailTutor.total_views,
          total_likes: detailTutor.total_likes,
          total_comments: detailTutor.total_comments,
        };
      }
    } catch (err) {
      console.warn("⚠️ Could not fetch detail for tutor", tutor.user_id);
    }
    return tutor;
  })
);




        //console.log("✅ All tutors fetched with details");
        

        // ✅ NORMALIZE DATA
list = list.map((tutor) => {
  const genderMap = { M: "Male", F: "Female", O: "Other" };

  // -------- MODES (always reliable)
  const modes = new Set();
  if (Array.isArray(tutor.class_modes)) tutor.class_modes.forEach(m => modes.add(m));
  if (Number(tutor.is_online) === 1) modes.add("Online");
  if (Number(tutor.is_offline) === 1) modes.add("Offline");
  if (Number(tutor.is_home_tuition) === 1) modes.add("Home Visit");

  // -------- LANGUAGES (FIXED)
let langs = tutor.languages;

// 🔥 universal language parser
if (typeof langs === "string") {
  langs = langs
    .replace(/[\|\/]/g, ",")      // handle "English | Hindi" or "English / Hindi"
    .split(",")
    .map(l => l.trim())
    .filter(l => l.length > 0);
}

if (!Array.isArray(langs)) {
  langs = [];
}



  return {
    ...tutor,
    gender_label: (genderMap[tutor.gender] || tutor.gender || "").trim(),
    class_modes: Array.from(modes),
    languages: langs,                     // ✅ now always array
    is_demo_available: Number(tutor.is_demo_available ?? 0),
  };
});




        //console.log("✅ Tutors normalized");

        // ⭐ SORT BY PLAN
        const order = { premium: 1, silver: 2, basic: 3 };
        list.sort(
          (a, b) => (order[a.membership_plan] || 4) - (order[b.membership_plan] || 4)
        );

        setTutorList(list);
        setAllTutors(list);
        setError("");
        //console.log("✅ Tutors set successfully");
      } catch (err) {
        console.error("❌ Tutor fetch failed:", err);
        setError("Failed to load tutors.");
        setTutorList([]);
        setAllTutors([]);
      } finally {
        setLoading(false);
      }

      setCurrentPage(1);
    };



    fetchTutors(); 
  }, [categoryId, searchQuery, searchCity, searchName, searchPincode, decodedCategory,refreshTutorsKey]);


    

      const [loggedStudentId, setLoggedStudentId] = useState(null);

      useEffect(() => {
        if (!loggedStudentId || tutorList.length === 0) return;

        tutorList.forEach(async (tutor) => {
          const res = await fetch(
            `https://kalakakshaaha.com/kks/api/v1/tutors/is-liked?tutor_id=${tutor.user_id}&student_id=${loggedStudentId}`
          );

          const data = await res.json();

          setLikedTutors((prev) => ({
            ...prev,

            [tutor.user_id]: data.liked,
          }));
        });
      }, [tutorList, loggedStudentId]);


      

      /* ----------------------  make like (TeamSingle style) ---------------------- */

      const toggleLike = async (tutorId) => {
        if (!loggedStudentId) {
          alert("Please login as student to like tutors");

          return;
        }

        const res = await fetch(
          "https://kalakakshaaha.com/kks/api/v1/tutors/like-toggle",

          {
            method: "POST",

            headers: { "Content-Type": "application/json" },

            body: JSON.stringify({
              tutor_id: tutorId,

              student_id: loggedStudentId,
            }),
          }
        );

        const data = await res.json();

        // Update UI instantly

        setTutorList((prev) =>
          prev.map((t) =>
            t.user_id === tutorId ? { ...t, total_likes: data.total_likes } : t
          )
        );

        setLikedTutors((prev) => ({
          ...prev,

          [tutorId]: data.liked,
        }));
      };

      //get token

      /* ----------------------  get token (TeamSingle style) ---------------------- */

      useEffect(() => {
        const token = localStorage.getItem("token");

        if (token) {
          try {
            const decoded = jwtDecode(token);

            if (decoded.role === "student") {
              setLoggedStudentId(decoded.id);
            }
          } catch (err) {
            console.log("Invalid token:", err);
          }
        }
      }, []);

      /* ---------------------- FETCH ADS (TeamSingle style) ---------------------- */
/* ---------------------- FETCH ADS (GLOBAL ONLY) ---------------------- */

useEffect(() => {
  const loadAds = async () => {
    try {
      const res = await fetch(
        "https://kalakakshaaha.com/kks/api/v1/ads_api.php"
      );
      const data = await res.json();

      if (data.success && Array.isArray(data.ads) && data.ads.length > 0) {
        setAdsList(data.ads);
      } else {
        setAdsList(fallbackAds);
      }
    } catch (err) {
      console.error("Ads fetch failed:", err);
      setAdsList(fallbackAds);
    }
  };

  loadAds();
}, []); // ✅ NO categoryId dependency







      /* ---------------------- SKILL CITY FILTER ---------------------- */

      const handleTagClick = (value) => {
        // 🔁 If same tag clicked again → UNSELECT

        if (activeSkillCity === value) {
          setActiveSkillCity(null);

          setTutorList(allTutors); // show all tutors

          setCurrentPage(1);

          return;
        }

        // ✅ Select new tag

        setActiveSkillCity(value);

        const [skillNamePart, cityNamePart] = value

          .split(" in ")

          .map((v) => v.trim());

        const filtered = allTutors.filter((tutor) => {
          if (!tutor.skills) return false;

          // Convert stored city_id → city name

          const tutorCity = getCityName(tutor.city_id)?.toLowerCase();

          // Convert skill IDs → names

          const tutorSkillNames = tutor.skills

            .split(",")

            .map((id) => getSkillName(id.trim()))

            .filter(Boolean)

            .map((name) => name.toLowerCase());

          const skillMatches = skillNamePart
            ? tutorSkillNames.includes(skillNamePart.toLowerCase())
            : true;

          const cityMatches = cityNamePart
            ? tutorCity === cityNamePart.toLowerCase()
            : true;

          return skillMatches && cityMatches;
        });

        setTutorList(filtered);

        setCurrentPage(1);
      };

     const sortedTutors = [...tutorList].sort((a, b) =>
      (a.display_name || a.full_name)
        .toLowerCase()
        .localeCompare((b.display_name || b.full_name).toLowerCase())
    );

      const totalPages = Math.max(1, Math.ceil(tutorList.length / itemsPerPage));

      const startIndex = (currentPage - 1) * itemsPerPage;

     const currentTutors = sortedTutors.slice(startIndex, startIndex + itemsPerPage);

      // 🎨 THEME COLORS BASED ON CATEGORY

      const themeColors = {
        singing: {
          lightBg: "#FFF5F5",

          primary: "#FF6B6B",

          cardBg: "#FFFFFF",

          secondary: "#FFC2C2",

          darkText: "#7A1F1F",
        },

        music: {
          lightBg: "#FFF3F0",

          primary: "#B83A2D",

          secondary: "#E58A81",

          darkText: "#5E1C17",

          cardBg: "#FFFFFF",
        },

        dance: {
          lightBg: "#F9F0FF",

          primary: "#AC4FBF",

          secondary: "#DBA0E7",

          darkText: "#5A2F64",

          cardBg: "#FFFFFF",
        },

        painting: {
          lightBg: "#E7F3F7",

          primary: "#3D7387",

          secondary: "#8EB6C4",

          darkText: "#1F3A43",

          cardBg: "#FFFFFF",
        },

        crafts: {
          lightBg: "#FFF0FB",

          primary: "#FF1DB2",

          secondary: "#FFA8E3",

          darkText: "#7B0A55",

          cardBg: "#FFFFFF",
        },

        more: {
          lightBg: "#FFF6E9",

          primary: "#F48C1D",

          secondary: "#F7BA70",

          darkText: "#783F0F",

          cardBg: "#FFFFFF",
        },

        default: {
          lightBg: "#F7F7F7",

          primary: "#8884FF",

          secondary: "#C5C1FF",

          darkText: "#2F2E5F",

          cardBg: "#FFFFFF",
        },
      };

      // Lowercase category (from URL)

      const currentCategory = decodedCategoryName.toLowerCase();

      // Pick theme or fallback

      const colors = themeColors[currentCategory] || themeColors.default;

      const [showFilter, setShowFilter] = useState(false);
        const [openDropdown, setOpenDropdown] = useState(null);

      // Comment modal state

      const [showCommentModal, setShowCommentModal] = useState(false);

      const [activeTutorId, setActiveTutorId] = useState(null);

 

const cityFilteredAreas =
  tempCities.length === 0
    ? dbAreas
    : dbAreas.filter(area =>
        tempCities.includes(Number(area.city_id))
      );
    const toggleDropdown = (name) => {
      setOpenDropdown(openDropdown === name ? null : name);
      
    };


      const searchCityFromQuery = searchQuery; // q=hyderabad

      //for fetching skills

      useEffect(() => {
        fetch("https://kalakakshaaha.com/kks/api/v1/total-skills")
          .then((res) => res.json())

          .then((data) => {
            if (data.success) setAllSkills(data.skills);
          });
      }, []);




  const getSkillName = (id) => {
    const s = allSkills.find((sk) => Number(sk.id) === Number(id));
    return s ? s.skill_title : "";
  };
      const getSkillNamesFromIds = (skillIds) => {
      if (!skillIds || !Array.isArray(allSkills)) return [];
      
      return skillIds
        .split(",")
        .map((id) => {
          const skill = allSkills.find((s) => Number(s.id) === Number(id.trim()));
          return skill ? skill.skill_title : null;
        })
        .filter(Boolean);
    };
      const TutorSkeleton = () => (
        <div className="col-lg-12 col-sm-12 mb-4">
            <div className="image-card-layout clean-shadow pastel" style={{ background: '#fff', padding: '20px' }}>
                <div className="card-header-flex">
                    <div className="profile-info-flex">
                        {/* Circle Avatar */}
                        <div className="skeleton-box" style={{ width: '70px', height: '70px', borderRadius: '50%' }}></div>
                        <div className="ms-3">
                            {/* Name */}
                            <div className="skeleton-box" style={{ width: '150px', height: '24px', marginBottom: '10px' }}></div>
                            {/* Badges */}
                            <div className="d-flex gap-2">
                                <div className="skeleton-box" style={{ width: '60px', height: '20px' }}></div>
                                <div className="skeleton-box" style={{ width: '60px', height: '20px' }}></div>
                            </div>
                        </div>
                    </div>
                    <div className="action-buttons-flex">
                        <div className="skeleton-box" style={{ width: '40px', height: '40px', borderRadius: '8px' }}></div>
                        <div className="skeleton-box" style={{ width: '100px', height: '40px', borderRadius: '8px' }}></div>
                    </div>
                </div>
                {/* Bio Section */}
                <div className="mt-4">
                    <div className="skeleton-box" style={{ width: '100px', height: '18px', marginBottom: '10px' }}></div>
                    <div className="skeleton-box" style={{ width: '100%', height: '14px' }}></div>
                    <div className="skeleton-box" style={{ width: '80%', height: '14px', marginTop: '5px' }}></div>
                </div>
                {/* Skills Section */}
                <div className="mt-4 d-flex gap-2">
                    <div className="skeleton-box" style={{ width: '70px', height: '25px', borderRadius: '15px' }}></div>
                    <div className="skeleton-box" style={{ width: '70px', height: '25px', borderRadius: '15px' }}></div>
                    <div className="skeleton-box" style={{ width: '70px', height: '25px', borderRadius: '15px' }}></div>
                </div>
            </div>
        </div>
    );
    const isSearchAll = decodedCategoryName.toLowerCase() === "all";

    const effectiveCategories = useMemo(() => {
  const set = new Set();

  // Route category (music / dance page)
  if (!isSearchAll && decodedCategoryName) {
    set.add(decodedCategoryName.toLowerCase());
  }

  // User-selected categories
  tempCategories.forEach(c => set.add(c.toLowerCase()));

  return Array.from(set);
}, [decodedCategoryName, tempCategories, isSearchAll]);

const categorySkills = useMemo(() => {
  // 🔍 SEARCH ALL → show all skills
  if (isSearchAll && effectiveCategories.length === 0) {
    return allSkills;
  }

  // 🎯 Filter skills by effective categories
  return allSkills.filter(skill => {
    const cat = allcategories.find(
      c => Number(c.id) === Number(skill.category_id)
    );
    if (!cat) return false;

    return effectiveCategories.includes(
      cat.category_name.toLowerCase()
    );
  });
}, [allSkills, allcategories, effectiveCategories, isSearchAll]);



      const [citySearch, setCitySearch] = useState("");
    const [skillSearch, setSkillSearch] = useState("");

    const filteredCityList = apiCities.filter((city) =>
      city.city_name.toLowerCase().includes(citySearch.toLowerCase())
    );

    const filteredSkills = categorySkills.filter((skill) =>
      skill.skill_title.toLowerCase().includes(skillSearch.toLowerCase())
    );


      // 🔍 Detect SEARCH ALL modeApply Filter

  

      const categoryTags = allcategories.map((cat) => cat.category_name);

      const generateStableRating = (userId) => {
        const base = (userId % 20) / 10; // 0.0 – 2.0

        return (3 + base).toFixed(1); // 3.0 – 5.0
      };

      const normalize = (v = "") => v.toString().toLowerCase().trim();

      const getPaginationRange = (current, total) => {
        const delta = 2; // pages around current

        const range = [];

        const rangeWithDots = [];

        let l;

        for (let i = 1; i <= total; i++) {
          if (
            i === 1 ||
            i === total ||
            (i >= current - delta && i <= current + delta)
          ) {
            range.push(i);
          }
        }

        for (let i of range) {
          if (l) {
            if (i - l === 2) {
              rangeWithDots.push(l + 1);
            } else if (i - l > 2) {
              rangeWithDots.push("...");
            }
          }

          rangeWithDots.push(i);

          l = i;
        }

        return rangeWithDots;
      };

      const isCitySearch = (query, tutors) =>
        tutors.some(
          (t) => t.city_name && t.city_name.toLowerCase() === query.toLowerCase()
        );

      const isCategorySearch = (query, categories) =>
        categories.some(
          (c) => c.category_name.toLowerCase() === query.toLowerCase()
        );
//continous error coming
      useEffect(() => {
        // 🔍 SEARCH ALL → show CATEGORIES

        if (isSearchAll) {
          setPageSkills(categoryTags);

          return;
        }

        // 📂 CATEGORY PAGE → show SKILLS

        if (!categoryId || categorySkills.length === 0) {
          setPageSkills([]);

          return;
        }

        setPageSkills(categorySkills.map((skill) => skill.skill_title));
      }, [isSearchAll, categoryId, categorySkills, categoryTags]);

      // 🔥 Route category → default selected filter
// 🔥 Route category → always sync filter to route
useEffect(() => {
  if (!decodedCategory || decodedCategory.toLowerCase() === "all") {
    setTempCategories([]);
    setActiveCategories([]);
    setApplyTick(t => t + 1);
    return;
  }

  setTempCategories([decodedCategory]);
  setActiveCategories([decodedCategory]);
  setApplyTick(t => t + 1);
}, [decodedCategory]);






      const toggleCity = (cityName) => {
        setActiveCities(
          (prev) =>
            prev.includes(cityName)
              ? prev.filter((c) => c !== cityName) // unselect
              : [...prev, cityName] // select
        );
      };

    const resetFilters = () => {
      setSelectedTags([]);
      setTempSkills([]);
      setTempCities([]);
      setTempGenders([]);
      setTempModes([]);
      setTempLanguages([]);
      setTempDemo(null);

      setActiveCities([]);
      setActiveGenders([]);
      setActiveModes([]);
      setActiveLanguages([]);
      setActiveDemo(null);

      setTutorList(allTutors);
      setError("");
      setCurrentPage(1);

      setTempExperience({ min: "", max: "" });
  setActiveExperience(null);
  setTempStates([]);
  setActiveStates([]);
  setTempCategories([]);
  setActiveCategories([]);
  setTempAreas([]);
  setActiveAreas([]);

    };




      /* ---------------------- views list  (TeamSingle style) ---------------------- */

      const increaseView = async (id) => {
        if (!loggedStudentId) return;

        // Optimistic update (immediately update UI)

        setTutorList((prev) =>
          prev.map((t) =>
            t.user_id === id ? { ...t, total_views: (t.total_views || 0) + 1 } : t
          )
        );

        const res = await fetch(
          "https://kalakakshaaha.com/kks/api/v1/tutors/view",

          {
            method: "POST",

            headers: { "Content-Type": "application/json" },

            body: JSON.stringify({ tutor_id: id, student_id: loggedStudentId }),
          }
        );

        const data = await res.json();

        if (data.success) {
          // Correct update using API return

          setTutorList((prev) =>
            prev.map((t) =>
              t.user_id === id ? { ...t, total_views: data.new_views } : t
            )
          );
        }
      };

      // comment function

      const updateTutorCommentCount = (amount) => {
        setTutorList((prev) =>
          prev.map((t) =>
            t.user_id === activeTutorId
              ? { ...t, total_comments: (t.total_comments || 0) + amount }
              : t
          )
        );
      };

      /* ---------------------- load comments  (TeamSingle style) ---------------------- */

      const loadComments = async (tutorId) => {
        const res = await fetch(
          `https://kalakakshaaha.com/kks/api/v1/tutors/comments/${tutorId}`
        );

        const data = await res.json();

        if (data.success) {
          setComments(data.comments);
        }
      };

      const openComments = (tutorId) => {
        setActiveTutorId(tutorId);

        loadComments(tutorId);

        setShowCommentModal(true);
      };

    // ✅ UNIVERSAL SKILL FILTER (ALL CATEGORIES – FIXED)
  useEffect(() => {

  
    let filtered = [...allTutors];

    // CATEGORY (search all)
// CATEGORY (GLOBAL — works on all pages)
if (activeCategories.length > 0) {
  filtered = filtered.filter((t) =>
    activeCategories.some((c) => {
      const tutorCategories = getTutorCategories(t, allSkills, allcategories);
      return tutorCategories.some(
        (tc) => normalizeValue(tc) === normalizeValue(c)
      );
    })
  );
}


    // 🌍 COUNTRY
// 🌍 COUNTRY FILTER — FIXED
if (activeCountries.length > 0) {
  filtered = filtered.filter((t) => {
    const city = allCities.find(
      c => Number(c.id) === Number(t.city_id)
    );
    if (!city) return false;

    const state = dbStates.find(
      s => Number(s.id) === Number(city.state_id)
    );
    if (!state) return false;

    return activeCountries.includes(Number(state.country_id));
  });
}

// AREA FILTER

// AREA FILTER (DEBUG VERSION)
if (activeAreas.length > 0) {
  filtered = filtered.filter((t) => {
    let tutorAreas = [];

    if (t.area) {
      tutorAreas.push(t.area.toLowerCase().trim());
    }

    if (t.branch_areas) {
      t.branch_areas
        .split(",")
        .map(a => a.toLowerCase().trim())
        .filter(Boolean)
        .forEach(a => tutorAreas.push(a));
    }


    const match = activeAreas.some(selected =>
      tutorAreas.includes(selected.toLowerCase().trim())
    );


    return match;
  });
}



    // SKILLS
    if (!isSearchAll && selectedTags.length > 0) {
      filtered = filtered.filter((tutor) => {
        let skillNames = [];

        if (tutor.skill_names) {
          skillNames = tutor.skill_names
            .split(",")
            .map((s) => s.toLowerCase().trim());
        } else if (tutor.skills) {
          skillNames = tutor.skills
            .split(",")
            .map((id) => getSkillName(id))
            .filter(Boolean)
            .map((s) => s.toLowerCase());
        }

        return selectedTags.some((tag) =>
          skillNames.includes(tag.toLowerCase())
        );
      });
    }

    // CITY
    if (activeCities.length > 0) {
      filtered = filtered.filter((t) =>
        activeCities.includes(Number(t.city_id))
      );
    }

    // STATE
  if (activeStates.length > 0) {
    filtered = filtered.filter((t) => {
      const city = allCities.find(
        c => Number(c.id) === Number(t.city_id)
      );
      return city && activeStates.includes(Number(city.state_id));
    });
  }


    // GENDER
    if (activeGenders.length > 0) {
      filtered = filtered.filter((t) =>
        activeGenders.some(
          (g) => normalizeValue(g) === normalizeValue(t.gender_label)
        )
      );
    }

    // EXPERIENCE
    if (activeExperience?.min || activeExperience?.max) {
      filtered = filtered.filter((t) => {
        const exp = Number(t.experience || 0);
        const min = Number(activeExperience.min || 0);
        const max = activeExperience.max
          ? Number(activeExperience.max)
          : Infinity;
        return exp >= min && exp <= max;
      });
    }

    // MODE
    if (activeModes.length > 0) {
      filtered = filtered.filter((t) =>
        t.class_modes?.some((m) =>
          activeModes.some(
            (am) => normalizeValue(am) === normalizeValue(m)
          )
        )
      );
    }

    // LANGUAGE
// 🌐 LANGUAGE — FIXED
if (activeLanguages.length > 0) {
  filtered = filtered.filter((t) =>
    t.languages?.some((l) => {
      const name = typeof l === "string" ? l : l.language_name;
      return activeLanguages.some(
        (al) => normalizeValue(al) === normalizeValue(name)
      );
    })
  );
}


    // DEMO
    if (activeDemo !== null) {
      filtered = filtered.filter(
        (t) => Number(t.is_demo_available) === Number(activeDemo)
      );
    }

    setTutorList(filtered);
    setCurrentPage(1);
    setError(filtered.length ? "" : "No tutors match your selected filters.");
  }, [
    allTutors,
    selectedTags,
    activeCities,
    activeStates,
    activeCategories,
     activeCountries,
    activeGenders,
    activeModes,
    activeLanguages,
    activeDemo,
    activeExperience,
    activeAreas,
    isSearchAll,
    applyTick, 
  ]);









      const submitComment = async () => {
        if (!newComment.trim()) return;

        await fetch("https://kalakakshaaha.com/kks/api/v1/tutors/comment", {
          method: "POST",

          headers: { "Content-Type": "application/json" },

          body: JSON.stringify({
            tutor_id: activeTutorId,

            student_id: loggedStudentId,

            category_id: categoryId,

            comment: newComment,
          }),
        });

        setNewComment("");

        // update UI immediately

        updateTutorCommentCount(1);

        loadComments(activeTutorId);
      };

    


  const getTutorCategories = (tutor, allSkills, allcategories) => {
    const set = new Set();

    // 1️⃣ FROM SKILL NAMES (MOST RELIABLE AFTER UPDATE)
    if (tutor?.skill_names) {
      tutor.skill_names
        .split(",")
        .map(s => s.trim())
        .filter(Boolean)
        .forEach(skillName => {
          const skill = allSkills.find(
            s => s.skill_title?.toLowerCase() === skillName.toLowerCase()
          );
          if (!skill) return;

          const cat = allcategories.find(
            c => Number(c.id) === Number(skill.category_id)
          );
          if (cat?.category_name) {
            set.add(cat.category_name);
          }
        });
    }

    // 2️⃣ FROM SKILL IDS (BACKUP)
    if (tutor?.skills) {
      tutor.skills
        .split(",")
        .map(id => Number(id.trim()))
        .filter(Boolean)
        .forEach(skillId => {
          const skill = allSkills.find(s => Number(s.id) === skillId);
          if (!skill) return;

          const cat = allcategories.find(
            c => Number(c.id) === Number(skill.category_id)
          );
          if (cat?.category_name) {
            set.add(cat.category_name);
          }
        });
    }

    // 3️⃣ LAST RESORT (PRIMARY CATEGORY)
    if (set.size === 0 && tutor?.category_name) {
      set.add(tutor.category_name);
    }

    return Array.from(set);
  };






      const updateComment = async () => {
        await fetch(
          `https://kalakakshaaha.com/kks/api/v1/tutors/comment/${editingComment.id}`,

          {
            method: "PUT",

            headers: { "Content-Type": "application/json" },

            body: JSON.stringify({ comment: editingComment.text }),
          }
        );

        setEditingComment(null);

        loadComments(activeTutorId);
      };

      /* ---------------------- delete comments  (TeamSingle style) ---------------------- */

      const deleteComment = async (id) => {
        await fetch(
          `https://kalakakshaaha.com/kks/api/v1/tutors/comment/${id}`,

          {
            method: "DELETE",
          }
        );

        loadComments(activeTutorId);

        updateTutorCommentCount(-1); // decrement count
      };

      /* ---------------------- like or unlike comments  (TeamSingle style) ---------------------- */

      const likeComment = async (id) => {
        await fetch("https://kalakakshaaha.com/kks/api/v1/comments/like", {
          method: "POST",

          headers: { "Content-Type": "application/json" },

          body: JSON.stringify({
            comment_id: id,

            student_id: loggedStudentId,
          }),
        });

        loadComments(activeTutorId);
      };

      //request sending

      const sendRequest = async (tutor) => {
        if (!loggedStudentId) {
          alert("Please login as student to send request");

          return;
        }

        const token = localStorage.getItem("token");

        if (!token) {
          alert("Authentication required");

          return;
        }

        const res = await fetch(
          "https://kalakakshaaha.com/kks/api/request/send",

          {
            method: "POST",

            headers: {
              "Content-Type": "application/json",

              Authorization: `Bearer ${token}`,
            },

            body: JSON.stringify({
              tutor_id: tutor.user_id,

              category: tutor.category,
            }),
          }
        );

        const data = await res.json();

        if (!data.success) {
          alert(data.message || "Request already sent");

          return;
        }

        if (data.success) {
          setTutorList((prev) =>
            prev.map((t) =>
              t.user_id === tutor.user_id ? { ...t, request_status: "sent" } : t
            )
          );
        }
      };
const isAnyFilterSelected = useMemo(() => {
  return (
     tempCountries.length ||  
    tempStates.length ||
    tempCities.length ||
    tempAreas.length || 
    tempCategories.length ||
    tempSkills.length ||
    tempGenders.length ||
    tempModes.length ||
    tempLanguages.length ||
    tempDemo !== null ||
    tempExperience?.min ||
    tempExperience?.max
  );
}, [
    tempCountries,
  tempStates,
  tempCities,
    tempAreas,    
  tempCategories,
  tempSkills,
  tempGenders,
  tempModes,
  tempLanguages,
  tempDemo,
  tempExperience
]);


const handleClearAll = () => {
  // ❌ Remove saved filters
  localStorage.removeItem("tutorFilters");

  // TEMP STATES
  setTempStates([]);
  setTempCities([]);
  setTempCategories([]);
  setTempSkills([]);
  setTempGenders([]);
  setTempModes([]);
  setTempLanguages([]);
  setTempAreas([]);  // ✅ ADD THIS

  setTempDemo(null);
  setTempExperience({ min: "", max: "" });

  //Active Countires

  setTempCountries([]);
setActiveCountries([]);

  // ACTIVE STATES
  setActiveStates([]);
  setActiveCities([]);
    setActiveAreas([]);
  setActiveCategories([]);
  setSelectedTags([]);
  setActiveGenders([]);
  setActiveModes([]);
  setActiveLanguages([]);
  setActiveDemo(null);
  setActiveExperience(null);

  // UI RESET
  setOpenDropdown(null);
  setCurrentPage(1);

  // 🔄 Re-run filter effect
  setApplyTick(t => t + 1);
};




      return (
        <Fragment>
          <Header />

          <div
            className="course-section padding-tb section-bg"
            style={{ background: colors.lightBg, minHeight: "100vh" }}
          >
            <div className="container" style={{ marginTop: 60 }}>
            

  <div className="filterbar-root" ref={filterRef}>

    <div className="filterbar-inner">
<button
  className="filter-fab"

>
  <i className="fa-solid fa-sliders"></i>
</button>
      
       <div className="filter-item">
        <button onClick={() => toggleDropdown("country")}>
          <i className="fa-solid fa-map" />
          {tempCountries.length ? `Countries (${tempCountries.length})` : "Country"}
          <i className={`fa-solid fa-chevron-${openDropdown === "country" ? "up" : "down"} ms-auto`} />
        </button>

        {openDropdown === "country" && (
          <div className="filter-dropdown">
            {dbCountries.map((c) => (
              <label key={c.id} className="filter-option">
                <span>{c.country_name}</span>
                <input
                  type="checkbox"
                  checked={tempCountries.includes(c.id)}
                  onChange={() =>
                    setTempCountries((p) =>
                      p.includes(c.id) ? p.filter(x => x !== c.id) : [...p, c.id]
                    )
                  }
                />
              </label>
            ))}
          </div>
        )}


      </div>


      {/* 🏛 STATE */}
      <div className="filter-item">
        <button onClick={() => toggleDropdown("state")}>
          <i className="fa-solid fa-map" />
          {tempStates.length ? `States (${tempStates.length})` : "State"}
          <i className={`fa-solid fa-chevron-${openDropdown === "state" ? "up" : "down"} ms-auto`} />
        </button>

        {openDropdown === "state" && (
          <div className="filter-dropdown">
           {countryFilteredStates.map((s) => (
              <label key={s.id} className="filter-option">
                <span>{s.state_name}</span>
                <input
                  type="checkbox"
                  checked={tempStates.includes(s.id)}
                  onChange={() =>
                    setTempStates((p) =>
                      p.includes(s.id) ? p.filter(x => x !== s.id) : [...p, s.id]
                    )
                  }
                />
              </label>
            ))}
          </div>
        )}
      </div>

      {/* 📍 CITY */}
      <div className="filter-item">
        <button onClick={() => toggleDropdown("city")}>
          <i className="fa-solid fa-location-dot" />
          {tempCities.length ? `Cities (${tempCities.length})` : "City"}
          <i className={`fa-solid fa-chevron-${openDropdown === "city" ? "up" : "down"} ms-auto`} />
        </button>

        {openDropdown === "city" && (
          <div className="filter-dropdown">
            <input
              type="text"
              placeholder="Search city..."
              value={citySearch}
              onChange={(e) => setCitySearch(e.target.value)}
            />

            {stateFilteredCities
              .filter(c =>
                c.city_name.toLowerCase().includes(citySearch.toLowerCase())
              )
              .map((city) => (
                <label key={city.id} className="filter-option">
                  <span>{city.city_name}</span>
                  <input
                    type="checkbox"
                    checked={tempCities.includes(city.id)}
                    onChange={() =>
                      setTempCities((p) =>
                        p.includes(city.id)
                          ? p.filter(x => x !== city.id)
                          : [...p, city.id]
                      )
                    }
                  />
                </label>
              ))}
          </div>
        )}
      </div>
{/* 🏘 AREA */}
<div className="filter-item">
  <button onClick={() => toggleDropdown("area")}>
    <i className="fa-solid fa-location-crosshairs" />
    {tempAreas.length ? `Areas (${tempAreas.length})` : "Area"}
    <i className={`fa-solid fa-chevron-${openDropdown === "area" ? "up" : "down"} ms-auto`} />
  </button>

  {openDropdown === "area" && (
    <div className="filter-dropdown">
      <input
        type="text"
        placeholder="Search area..."
        value={areaSearch}
        onChange={(e) => setAreaSearch(e.target.value)}
      />

      {cityFilteredAreas
        .filter(a =>
          a.area_name.toLowerCase().includes(areaSearch.toLowerCase())
        )
        .map((area, i) => (
          <label key={i} className="filter-option">
            <span>{area.area_name}</span>
            <input
              type="checkbox"
              checked={tempAreas.includes(area.area_name)}
              onChange={() => {
                //  ADD THIS CONSOLE LOG
            
                
                setTempAreas(p => {
                  const newAreas = p.includes(area.area_name)
                    ? p.filter(x => x !== area.area_name)
                    : [...p, area.area_name];
                  
                  // ADD THIS CONSOLE LOG
             
                  return newAreas;
                });
              }}
            />
          </label>
        ))}
    </div>
  )}
</div>

      {/* 🗂 CATEGORY */}
      <div className="filter-item">
        <button onClick={() => toggleDropdown("category")}>
          <i className="fa-solid fa-layer-group" />
          {tempCategories.length ? `Categories (${tempCategories.length})` : "Category"}
          <i className={`fa-solid fa-chevron-${openDropdown === "category" ? "up" : "down"} ms-auto`} />
        </button>

        {openDropdown === "category" && (
          <div className="filter-dropdown">
            {categoryTags.map((cat) => (
              <label key={cat} className="filter-option">
                <span>{cat}</span>
                <input
                  type="checkbox"
                  checked={tempCategories.includes(cat)}
                  onChange={() =>
                    setTempCategories((p) =>
                      p.includes(cat) ? p.filter(x => x !== cat) : [...p, cat]
                    )
                  }
                />
              </label>
            ))}
          </div>
        )}
      </div>

      {/*  SKILLS */}
      <div className="filter-item">
        <button onClick={() => toggleDropdown("skill")}>
          <i className="fa-solid fa-music" />
          {tempSkills.length ? `Sub Category (${tempSkills.length})` : "Sub Category"}
          <i className={`fa-solid fa-chevron-${openDropdown === "skill" ? "up" : "down"} ms-auto`} />
        </button>

        {openDropdown === "skill" && (
          <div className="filter-dropdown">
            <input
              type="text"
              placeholder="Search sub category..."
              value={skillSearch}
              onChange={(e) => setSkillSearch(e.target.value)}
            />

            {filteredSkills.map((skill, i) => (
              <label key={i} className="filter-option">
                <span>{skill.skill_title}</span>
                <input
                  type="checkbox"
                  checked={tempSkills.includes(skill.skill_title)}
                  onChange={() =>
                    setTempSkills((p) =>
                      p.includes(skill.skill_title)
                        ? p.filter(x => x !== skill.skill_title)
                        : [...p, skill.skill_title]
                    )
                  }
                />
              </label>
            ))}
          </div>
        )}
      </div>

      {/* 👤 GENDER */}
      <div className="filter-item">
        <button onClick={() => toggleDropdown("gender")}>
          <i className="fa-solid fa-user" />
          {tempGenders.length ? `Gender (${tempGenders.length})` : "Gender"}
          <i className={`fa-solid fa-chevron-${openDropdown === "gender" ? "up" : "down"} ms-auto`} />
        </button>

        {openDropdown === "gender" && (
          <div className="filter-dropdown">
            {dbGenders.map((g) => (
              <label key={g} className="filter-option">
                <span>{g}</span>
                <input
                  type="checkbox"
                  checked={tempGenders.includes(g)}
                  onChange={() =>
                    setTempGenders((p) =>
                      p.includes(g) ? p.filter(x => x !== g) : [...p, g]
                    )
                  }
                />
              </label>
            ))}
          </div>
        )}
      </div>

      {/*  EXPERIENCE */}
      <div className="filter-item">
        <button onClick={() => toggleDropdown("experience")}>
          <i className="fa-solid fa-briefcase" />
          {tempExperience.min || tempExperience.max
            ? `${tempExperience.min || 0} - ${tempExperience.max || "∞"} yrs`
            : "Experience"}
          <i className={`fa-solid fa-chevron-${openDropdown === "experience" ? "up" : "down"} ms-auto`} />
        </button>

        {openDropdown === "experience" && (
          <div className="filter-dropdown">
            <input
              type="number"
              placeholder="Min years"
              value={tempExperience.min}
              onChange={(e) =>
                setTempExperience(p => ({ ...p, min: e.target.value }))
              }
            />
            <input
              type="number"
              placeholder="Max years"
              value={tempExperience.max}
              onChange={(e) =>
                setTempExperience(p => ({ ...p, max: e.target.value }))
              }
            />
          </div>
        )}
      </div>

      <div className="filter-item">
        <button onClick={() => toggleDropdown("demo")}>
          <i className="fa-solid fa-video me-2"></i>
          {tempDemo !== null ? (tempDemo ? "Demo: Yes" : "Demo: No") : "Demo Available"}
          <i className={`fa-solid fa-chevron-${openDropdown === "demo" ? "up" : "down"} ms-auto`} />
        </button>

        {openDropdown === "demo" && (
          <div className="dropdown-menu-content">
            {[{ label: "Yes", value: 1 }, { label: "No", value: 0 }].map(opt => (
              <label key={opt.value} className="dropdown-item">
                <span>{opt.label}</span>
                <input
                  type="radio"
                  name="demo"
                  checked={tempDemo === opt.value}
                  onChange={() => setTempDemo(opt.value)}
                />
              </label>
            ))}
          </div>
        )}
            </div>

      {/* 🖥 MODE */}
      <div className="filter-item">
        <button onClick={() => toggleDropdown("mode")}>
          <i className="fa-solid fa-laptop-house" />
          {tempModes.length ? `Mode (${tempModes.length})` : "Mode"}
          <i className={`fa-solid fa-chevron-${openDropdown === "mode" ? "up" : "down"} ms-auto`} />
        </button>

        {openDropdown === "mode" && (
          <div className="filter-dropdown">


  {MODE_MAP.map(({ label, value }) => (
    <label key={value} className="filter-option">
      <span>{label}</span>
      <input
        type="checkbox"
        checked={tempModes.includes(value)}
        onChange={() =>
          setTempModes((p) =>
            p.includes(value)
              ? p.filter(x => x !== value)
              : [...p, value]
          )
        }
      />
    </label>
  ))}

          </div>
        )}
      </div>

      {/* 🌐 LANGUAGE */}
      <div className="filter-item">
        <button onClick={() => toggleDropdown("language")}>
          <i className="fa-solid fa-language" />
          {tempLanguages.length ? `Languages (${tempLanguages.length})` : "Languages"}
          <i className={`fa-solid fa-chevron-${openDropdown === "language" ? "up" : "down"} ms-auto`} />
        </button>

        {openDropdown === "language" && (
          <div className="filter-dropdown">
            {dbLanguages.map((lang) => (
              <label key={lang} className="filter-option">
                
                <span>{lang}</span>
                <input
                  type="checkbox"
                  checked={tempLanguages.includes(lang)}
                  onChange={() =>
                    setTempLanguages((p) =>
                      p.includes(lang) ? p.filter(x => x !== lang) : [...p, lang]
                    )
                  }
                />
              </label>
            ))}
          </div>
        )}
      </div>

      {/*  ACTIONS */}
      <div className="filter-actions">
        <button
          className="filter-apply"
  onClick={() => {

    const filters = {
      states: tempStates,
      cities: tempCities,
      categories: tempCategories,
      skills: tempSkills,
      genders: tempGenders,
      modes: tempModes,
      languages: tempLanguages,
      experience: tempExperience,
      demo: tempDemo,
       countries: tempCountries,
        areas: tempAreas
    };

    localStorage.setItem("tutorFilters", JSON.stringify(filters));
    
    setActiveStates(tempStates);
    setActiveCities(tempCities);
    setActiveCategories(tempCategories);
    setSelectedTags(tempSkills);
    setActiveGenders(tempGenders);
    setActiveModes(tempModes);
    setActiveLanguages(tempLanguages);
    setActiveExperience(tempExperience);
    setActiveDemo(tempDemo);
    setActiveCountries(tempCountries);
    setActiveAreas([...tempAreas]);

    if (tempCategories.length > 0) {
      window.history.pushState({}, "", "/tutors/all");
    }

    setApplyTick(t => t + 1);
    setOpenDropdown(null);
  }}

        >
          Apply
        </button>

  {isAnyFilterSelected && (
    <button className="filter-clear" onClick={handleClearAll}>
      Clear
    </button>
  )}

      </div>

    </div>
  </div>
<h3 >Available Tutors</h3>

              {/* ---------- ADS + TUTOR CARDS ---------- */}

              <div className="row g-4">
                {/* ⭐ ADS (RIGHT SIDE) */}




                {/* ---------- TUTOR CARDS (FULL ORIGINAL LAYOUT) ---------- */}

             <div className="col-12 col-md-8 col-lg-9">
                  <div className="section-wrapper">
                  {loading && (
                <div className="row g-4">
                    {[1, 2, 3].map((n) => <TutorSkeleton key={n} />)}
                </div>
            )}

                    {error && <p style={{ color: colors.secondary }}>{error}</p>}

                    {isFiltering && (
                      <div className="filter-feedback">
                        <span className="pulse-dot"></span>
                        Updating tutors based on selected skills...
                      </div>
                    )}

                    {selectedTags.length > 0 && tutorList.length === 0 && (
                      <div
                        style={{
                          marginTop: "15px",

                          padding: "12px",

                          textAlign: "center",

                          color: "#777",

                          fontWeight: "500",

                          background: "#fff",

                          borderRadius: "8px",

                          boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                        }}
                      >
                        No tutors are there for the selected skill
                      </div>
                    )}

                    {!loading && !error && currentTutors.length > 0 && (
                      <>
                     <div className="row g-4">
                      {currentTutors.map((tutor, i) => (
                          <div className="col-lg-12 col-sm-12" key={i}>
                           <div
                              className={`image-card-layout clean-shadow pastel plan-${tutor.membership_plan}`}
                              style={{ background: colors.cardBg, cursor: "pointer" }}
                              onClick={() => {
                                increaseView(tutor.user_id);
                                navigate(`/tutor/${tutor.full_name
                                  .toLowerCase()
                                  .replace(/\s+/g, "-")}-${tutor.city_id}?id=${tutor.user_id}`);
                              }}
                            >
                              <div className="card-header-flex">
                                <div className="profile-info-flex">
                                  <div className="profile-thumb">
                                    {/* <img

                                                                          src={tutor.profile_photo

                                                                              ? `https://kalakakshaaha.sanvima.net/uploads/tutors/${tutor.profile_photo}`

                                                                              : profile_image}

                                                                          alt={tutor.full_name}

                                                                      /> */}

<img
  src={
    tutor.profile_photo
      ? `https://kalakakshaaha.com/uploads/tutors/${tutor.profile_photo}`
      : profile_image
  }
  alt={tutor.full_name}
  className="profile-avatar-large clickable-avatar"
onClick={() => {
   // 👈 check this
  setPreviewImage(
    tutor.profile_photo
      ? `https://kalakakshaaha.com/uploads/tutors/${tutor.profile_photo}`
      : profile_image
  );
  setShowImagePreview(true);
}}
/>


                                  </div>

                                  <div>
                                    <h6 className="name-style-1">
                                      {/* {tutor.full_name} */}

                                      <Link
                                        onClick={() =>
                                          increaseView(tutor.user_id)
                                        }
                                        to={`/tutor/${tutor.full_name

                                          .toLowerCase()

                                          .replace(/\s+/g, "-")}-${
                                          tutor.city_id
                                        }?id=${tutor.user_id}`}
                                      >
                                        <h4 style={{ margin: "2px 0" }}>
                                        {tutor.display_name || tutor.full_name}
                                        </h4>
                                      </Link>

                                      {tutor.membership_plan === "premium" && (
                                        <span className="plan-badge premium">
                                          Premium
                                        </span>
                                      )}

                                      {tutor.membership_plan === "silver" && (
                                        <span className="plan-badge silver">
                                          Silver
                                        </span>
                                      )}

                                       {/* {tutor.membership_plan === "basic" && (
                                        <span className="plan-badge basic">
                                          Basic
                                        </span>
                                      )}

                                      {/* <span>{tutor.category}</span> */}
                                    </h6>

                                    <div className="info-row-style-1">
                                      <span className="info-badge blue">
                                        <i className="fa-solid fa-briefcase me-1"></i>
                                        {tutor.experience} yrs
                                      </span>

                                      <span className="info-badge green">
                                        <i className="fa-solid fa-location-dot me-1"></i>

                                        {getCityName(tutor.city_id)}
                                      </span>

  <span className="info-badge blue">
    {(() => {
      const tutorCategories = getTutorCategories(
        tutor,
        allSkills,
        allcategories
      );
      return tutorCategories.length
        ? tutorCategories.join(", ")
        : null;
    })()}
  </span>

  

                                      {/*<span className="info-badge gold">
                                        <i className="fa-solid fa-star"></i>

                                        {tutor.rating ??
                                          generateStableRating(tutor.user_id)}
                                      </span>*/}
                                    </div>
                                  </div>
                                </div>

                                <div className="action-buttons-flexx">
                                  <div className="profile-menu dots-above">
                                    {/* <i className="fa-solid fa-ellipsis-vertical"></i> */}
                                  </div>

                                  <div className="action-buttons-flex">
                                    <button
                                      className="icon-btn like-btn"
                                      onClick={() => toggleLike(tutor.user_id)}
                                    >
                                      <i
                                        className={`fa-solid fa-heart ${
                                          likedTutors[tutor.user_id]
                                            ? "liked-red"
                                            : ""
                                        }`}
                                        style={{
                                          color: likedTutors[tutor.user_id]
                                            ? "red"
                                            : "#f9f4f4ff",
                                        }}
                                      ></i>
                                    </button>

                                    {/* {tutor.request_status === "sent" ? (
                                      <button className="icon-btnn mail-btn disabled">
                                        <i className="fa-solid fa-check"></i>
                                        Sent
                                      </button>
                                    ) : (
                                        <button
                                        className="icon-btnn mail-btn"
                                        onClick={() => sendRequest(tutor)}
                                      >
                                        {/*<i className="fa-solid fa-user-plus"></i>
                                        Request
                                      </button>
                                    )}*/}
                                  </div>
                                </div>
                              </div>

                              {/* BIO */}

<div className="bio-wrapper">
  {(() => {
    const finalBio =
      tutor.bio ||
      "Hello! I am a passionate educator dedicated to sharing my knowledge and helping students reach their full potential. With a learner-centric approach, I focus on building strong fundamentals, boosting confidence, and making each session engaging and effective. I adapt my teaching style to suit individual learning needs and goals.";

    const plainBio = finalBio.replace(/<[^>]*>/g, "");

    return (
      <>
        <div
          className="bio-texttt"
          dangerouslySetInnerHTML={{ __html: finalBio }}
        />

        {plainBio.length > 0 && (
          <Link
            to={`/tutor/${tutor.full_name
              .toLowerCase()
              .replace(/\s+/g, "-")}-${tutor.city_id}?id=${tutor.user_id}`}
          >
            Read More
          </Link>
        )}
      </>
    );
  })()}
</div>
  
                              {/* SKILLS */}

                              {/* <div className="skills-section">

                                                              <h5 className="section-title">Skills</h5>

                                                              <div className="skills-wrapper">

                                                                  {tutor.skills &&

                                                                      tutor.skills.split(",").map((tag, idx) => (

                                                                          <span key={idx} className="skill-chip">

                                                                              {tag.trim()}

                                                                          </span>

                                                                      ))}

                                                              </div>

                                                          </div> */}

  <div className="skills-section">
    <h5 ></h5>

    <div className="skills-wrapper">
      {(() => {
        let skillNames = [];

        if (tutor.skill_names && tutor.skill_names.trim() !== "") {
          skillNames = tutor.skill_names
            .split(",")
            .map((s) => s.trim())
            .filter(Boolean);
        }
        else if (tutor.skills && tutor.skills.trim() !== "") {
          skillNames = getSkillNamesFromIds(tutor.skills); //  USE NEW FUNCTION
        }

        if (skillNames.length === 0) {
          return (
            <span className="skill-chip muted">
              No skills listed
            </span>
          );
        }

        const visibleSkills = skillNames.slice(0, 9);
        const remainingCount = skillNames.length - 9;

        return (
          <>
            {visibleSkills.map((name, idx) => (
              <span key={`skill-${tutor.user_id}-${idx}`} className="skill-chip">
                {name}
              </span>
            ))}

            {remainingCount > 0 && (
              <span className="skill-chip more-chip">
                +{remainingCount} more
              </span>
            )}
          </>
        );
      })()}
    </div>
  </div>

                              <div className="post-stats insta-style">
                                <span>
                                  <i className="fa-regular fa-heart"></i>{" "}
                                  {tutor.total_likes}
                                </span>

                                {/* <span><i className="fa-regular fa-comment"></i> 56</span>

                                <span
                                  onClick={() => openComments(tutor.user_id)}
                                  style={{ cursor: "pointer" }}
                                >
                                  <i className="fa-regular fa-comment"></i>{" "}
                                  {tutor.total_comments}
                                </span> */}

                                <span>
                                  <i className="fa-regular fa-eye"></i>{" "}
                                  {tutor.total_views}
                                </span>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>

                        {/* COMMENT MODAL */}

                        {showCommentModal && (
                          <div className="comment-modal-overlay">
                            <div className="comment-modal">
                              <div className="modal-header">
                                <h4>Comments</h4>

                                <button
                                  className="close-btn"
                                  onClick={() => setShowCommentModal(false)}
                                >
                                  ✕
                                </button>
                              </div>

                              <div className="modal-body">
                                {/* COMMENT LIST */}

                                <div className="comments-list">
                                  {comments.length === 0 && (
                                    <p style={{ color: "#777" }}>No comments yet</p>
                                  )}

                                  {comments.map((c) => (
                                    <div
                                      className="comment-item"
                                      key={c.comment_id}
                                    >
                                      <img
                                        src={
                                          c.student_profile_photo
                                            ? `https://kalakakshaaha.com/kks/${c.student_profile_photo}`
                                            : "/default.png"
                                        }
                                        className="comment-avatar"
                                      />

                                      <div className="comment-content">
                                        <strong>{c.full_name}</strong>

                                        {/* EDIT MODE */}

                                        {editingComment?.id === c.comment_id ? (
                                          <textarea
                                            value={editingComment.text}
                                            onChange={(e) =>
                                              setEditingComment({
                                                ...editingComment,

                                                text: e.target.value,
                                              })
                                            }
                                            className="edit-textarea"
                                          />
                                        ) : (
                                          <p>{c.comment_text}</p>
                                        )}

                                        <div className="comment-actions">
                                          {/* EDIT BUTTON */}

                                          {loggedStudentId === c.student_id &&
                                            editingComment?.id !== c.comment_id && (
                                              <button
                                                className="comment-btn"
                                                onClick={() =>
                                                  setEditingComment({
                                                    id: c.comment_id,

                                                    text: c.comment_text,
                                                  })
                                                }
                                              >
                                                Edit
                                              </button>
                                            )}

                                          {/* SAVE BUTTON */}

                                          {editingComment?.id === c.comment_id && (
                                            <button
                                              className="comment-btn save"
                                              onClick={updateComment}
                                            >
                                              Save
                                            </button>
                                          )}

                                          {/* CANCEL BUTTON */}

                                          {editingComment?.id === c.comment_id && (
                                            <button
                                              className="comment-btn cancel"
                                              onClick={() =>
                                                setEditingComment(null)
                                              }
                                            >
                                              Cancel
                                            </button>
                                          )}

                                          {/* DELETE BUTTON */}

                                          {loggedStudentId === c.student_id && (
                                            <button
                                              className="comment-btn delete"
                                              onClick={() =>
                                                deleteComment(c.comment_id)
                                              }
                                            >
                                              Delete
                                            </button>
                                          )}

                                          {/* LIKE BUTTON */}

                                          <button
                                            className="comment-btn like"
                                            onClick={() =>
                                              likeComment(c.comment_id)
                                            }
                                          >
                                            ❤️ {c.likes || 0}
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  ))}
                                </div>

                                {/* ADD COMMENT BOX */}

                                {loggedStudentId && (
                                  <div className="add-comment-box">
                                    <textarea
                                      value={newComment}
                                      onChange={(e) =>
                                        setNewComment(e.target.value)
                                      }
                                      placeholder="Write a comment..."
                                    ></textarea>

                                    <button
                                      className="btn-submit"
                                      onClick={submitComment}
                                    >
                                      Post
                                    </button>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}

                        {/* Pagination */}

                        <div className="d-flex justify-content-center mt-4 flex-wrap gap-2">
                          {getPaginationRange(currentPage, totalPages).map(
                            (page, i) =>
                              page === "..." ? (
                                <span key={i} className="pagination-dots">
                                  ...
                                </span>
                              ) : (
                                <button
                                  key={i}
                                  onClick={() => {
                                    setCurrentPage(page);

                                    window.scrollTo({ top: 0, behavior: "smooth" });
                                  }}
                                  className={`pastel-page-btn ${
                                    currentPage === page ? "active" : ""
                                  }`}
                                  style={{
                                    borderColor: colors.primary,

                                    background:
                                      currentPage === page
                                        ? colors.primary
                                        : "transparent",

                                    color:
                                      currentPage === page
                                        ? "#fff"
                                        : colors.darkText,
                                  }}
                                >
                                  {page}
                                </button>
                              )
                          )}
                        </div>
                      </>
                    )}
                  </div>
                </div>

<div className="col-12 col-md-4 col-lg-3">
  <div className="ads-sidebar">
    {adsList.slice(0, 5).map((ad, i) => {
      const imgSrc =
        ad.image_url && ad.image_url.trim()
          ? `https://kalakakshaaha.com/uploads/ads/${ad.image_url}`
          : ad.imgUrl;

      const redirect =
        ad.redirect_url && ad.redirect_url.trim()
          ? ad.redirect_url.startsWith("http")
            ? ad.redirect_url
            : `https://${ad.redirect_url}`
          : "#";

      return (
        <div key={i} className="ad-item mb-3">
          <a  target="_blank" rel="noopener noreferrer">
            <img
              src={imgSrc}
              className="w-100 rounded"
              alt={ad.title || "Advertisement"}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "/assets/images/fallback-ad.png";
              }}
            />
          </a>
        </div>
      );
    })}
  </div>
</div>
              </div>

              {/* ---------- SKILL-CITY TAGS ---------- */}

              {allTutors.length > 0 && (
                <div className="py-5 mt-5">
                  <h3
                    className="mb-4 pastel-city-title"
                    style={{ color: colors.darkText }}
                  >
                    <i
                      className="fa-solid fa-map-pin me-2"
                      style={{ color: colors.secondary }}
                    ></i>
                    Discover Tutors Across Cities
                  </h3>

                  <div className="row g-3 justify-content-center">
                    {[
                      ...new Set(
                        allTutors.flatMap((tutor) => {
                          const cityName = getCityName(tutor.city_id);

                          if (!cityName) return [];

                          let skillList = [];

                          // 🟢 Search API → skill names

                          if (tutor.skill_names) {
                            skillList = tutor.skill_names

                              .split(",")

                              .map((s) => s.trim())

                              .filter(Boolean);
                          }

                          // 🟢 Category API → skill IDs
                          else if (tutor.skills && tutor.skills.trim() !== "") {

                            skillList = tutor.skills

                              .split(",")

                              .map((id) => getSkillName(id.trim()))

                              .filter(Boolean);
                          }

                          return skillList.map(
                            (skill) => `${skill} in ${cityName}`
                          );
                        })
                      ),
                    ]

                      .slice(0, 16)

                      .map((skillCity, i) => (
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12" key={i}>
                          <Link
                            to="#"
                            className={`pastel-city-card ${
                              activeSkillCity === skillCity ? "active" : ""
                            }`}
                            style={{
                              background:
                                activeSkillCity === skillCity
                                  ? colors.primary
                                  : colors.cardBg,

                              border: `1px solid ${colors.primary}`,
                            }}
                            onClick={() => {
                              handleTagClick(skillCity);

                              window.scrollTo({ top: 0, behavior: "smooth" });
                            }}
                          >
                            <span
                              className="pastel-city-link"
                              style={{
                                color:
                                  activeSkillCity === skillCity
                                    ? "#fff"
                                    : colors.darkText,
                              }}
                            >
                              {skillCity}
                            </span>
                          </Link>
                        </div>
                      ))}
                  </div>
                </div>
              )}
            </div>
          </div>

          <Footer />
       {/* IMAGE PREVIEW MODAL */}
{/* IMAGE PREVIEW MODAL */}
{/* IMAGE PREVIEW MODAL */}
{showImagePreview &&
  createPortal(
    <div
      className="image-preview-overlay"
      onClick={() => setShowImagePreview(false)}
    >
      <div
        className="image-preview-container"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          className="image-preview-close"
          onClick={() => setShowImagePreview(false)}
        >
          ✕
        </button>

        <img src={previewImage} alt="Preview" />
      </div>
    </div>,
    document.body
  )}


</Fragment>
      );
    };

    export default Singing;
